import styles from './ProductsContainerBox.module.css';
import { ProductTile } from '../../productTile';
import { IMarketPlaceProduct, IMarketingBanner } from '@/interfaces';
import { DynamicElementType } from '@/lib/constants';
import React from 'react';
import { DynamicBanner } from '@/components/shared/dynamicBanner';
import Image from 'next/image';

type props = {
    products: IMarketPlaceProduct[]
    marketingBanner: IMarketingBanner[]
}
export function ProductsContainerBox({ products, marketingBanner }: props) {
    return (
        <div className={`${styles.productDetailsBox} ${(!products || products.length === 0) && styles.noProductFoundDiv}`}>
            {
                (!products || products.length === 0) ?
                    <div className={styles.noProductFound}>
                        <figure>
                            <Image width={76} height={80} className='img-responsive' src="/assets/images/marketplace/noProductFound.svg" alt="" />
                        </figure>
                        <span>Oops! No Product Found</span>
                    </div>
                    :
                    <div className={styles.productGridBox}>
                        {products && products.map((product, idx) => {
                            const position = ((idx) / 4);
                            const data = marketingBanner?.find((f) => f.position == position) || {} as any
                            return (
                                <React.Fragment key={idx}>
                                    {(Object.keys(data).length > 0) && <DynamicBanner bannersData={data} isSubcatPage={true} />}
                                    <ProductTile product={product} isFirstCatAndProduct={idx === 0 || idx === 1} elementType={DynamicElementType.h2} />
                                </React.Fragment>
                            );
                        })}
                    </div>
            }
        </div>
    )
}